import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { sidemenu } from './sidemenu';
import { environment } from 'src/environments/environment';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-account-deatils',
    templateUrl: './account-details.component.html',
    styleUrls: [
        '../../../../../../../src/assets/css/ds-core.css',
        '../../../../../../../src/assets/css/ds-button.css',
        '../../../../../../../src/assets/css/ds-card.css',
        '../../../../../../../src/assets/css/ds-form.css',
        '../../../../../../../src/assets/css/ds-modal.css',
        '../../../../../../../src/assets/css/ds-step-indicator.css',
        '../../../../../../../src/assets/css/ds-tabs.css',
        '../../../../../../../src/assets/css/ds-tile.css',
        './account-details.component.css'
    ],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [RouterOutlet]
})
export class AccountDetailsComponent implements OnInit {
  menudata: any[] = [];
  selectedsidemenuitemkey: any;
  selectedmenuitem: any;
  sidemenudata: any;
  groupedmenudata: [string, unknown][];
  shoulddisplaysection: boolean;
  shoulddisplay: boolean;
  initial: boolean;

  constructor() {}
  submenu = sidemenu;

  ngOnInit(): void {
    this.submenu.items.forEach((x, index) => {
      if (index === 1 || index === 2) this.findAndUpdateItem(x, 'Section A');
      else this.findAndUpdateItem(x, 'Section B');
    });
    this.menudata = [...this.menudata, ...this.submenu.items];
    this.selectedsidemenuitemkey =
      this.menudata && this.menudata.length > 0 ? this.menudata[0].menuKey : 0;
    this.selectedmenuitem =
      this.menudata.length > 0 ? this.menudata[0].label : '';
    this.sidemenudata =
      this.selectedmenuitem !== ''
        ? this.menudata.filter((x) => x.label.toLocaleLowerCase() === 'home')[0]
            .submenu
        : [];
    this.groupedmenudata =
      this.selectedmenuitem !== ''
        ? Object.entries(
            this.sidemenudata.reduce((r, a, index) => {
              r[a.section] = [...(r[a.section] || []), a];

              return r;
            }, {})
          )
        : [];

    this.shoulddisplaysection = true;
    this.shoulddisplay = false;
    this.initial = true;
    this.selectedmenuitem = '14630000';
    //this.menudata = this.dataService.data;
  }

  onSidemenuItemClicked(event) {
    if (environment.debug) console.log(event);
  }

  findAndUpdateItem(rootItem, section) {
    rootItem['section'] = section;
    rootItem['selected'] = false;
    rootItem['expanded'] = false;

    if (rootItem.submenu && rootItem.submenu.length > 0) {
      rootItem.submenu.forEach((y, index) => {
        if (index === 1 || index === 2) this.findAndUpdateItem(y, 'Section A');
        else this.findAndUpdateItem(y, 'Section B');
      });
    }
  }
}
